async function fetchFeedback(payload) {
  const BASE_URL =
    "https://us-central1-charming-shield-300804.cloudfunctions.net/addvendorcomponentstg"; // Replace with your actual function URL

  const url = `${BASE_URL}/feedback`;
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Failed to submit feedback");
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error in fetchFeedback:", err);
    throw err;
  }
}

// const saveUserBehaviour = async (generatedItems, modifiedItems) => {

//   // Clone modifiedItems to avoid mutating the original object
//   const objectForTheAPI = { ...modifiedItems };
//   console.log('generatedItems : ', JSON.stringify(generatedItems));
//   console.log('modifiedItems : ', JSON.stringify(modifiedItems));
//   // Remove unwanted properties if they exist
//   delete objectForTheAPI.Material;
//   delete objectForTheAPI.Work;

//     // Add original and corrected JSON structures as strings
//     objectForTheAPI.original_json = JSON.stringify({
//       material: generatedItems.material,
//       work: generatedItems.work,
//     });

//     objectForTheAPI.corrected_json = JSON.stringify({
//       material: modifiedItems.Material,
//       work: modifiedItems.Work,
//     });

//   console.log("objectForTheAPI:", JSON.stringify(objectForTheAPI));

//   // Send the data
//   await fetchFeedback(objectForTheAPI);
// };

const filterWorkItem = (item) => {
  const { quantity, unit, rate, gst, description, vendorCategory } = item;
  return { quantity, unit, rate, gst, description, vendorCategory };
};

const filterMaterialItem = (item) => {
  const { quantity, unit, rate, gst, type, specification } = item;
  return { quantity, unit, rate, gst, type, specification };
};

const saveUserBehaviour = async (generatedItems, modifiedItems) => {
  // Prepare filtered versions
  const filteredOriginal = {
    material: (generatedItems.material || []).map(filterMaterialItem),
    work: (generatedItems.work || []).map(filterWorkItem),
  };

  const filteredCorrected = {
    material: (modifiedItems.Material || []).map(filterMaterialItem),
    work: (modifiedItems.Work || []).map(filterWorkItem),
  };

  // Clone modifiedItems and remove unwanted top-level keys
  const objectForTheAPI = { ...modifiedItems };
  delete objectForTheAPI.Material;
  delete objectForTheAPI.Work;

  // Attach filtered JSON strings
  objectForTheAPI.original_json = JSON.stringify(filteredOriginal);
  objectForTheAPI.corrected_json = JSON.stringify(filteredCorrected);

  console.log("objectForTheAPI:", JSON.stringify(objectForTheAPI));

  // Send the data
  await fetchFeedback(objectForTheAPI);
};

export default saveUserBehaviour;
